import { render } from "./TruckDescription.vue?vue&type=template&id=bfab2618"
import script from "./TruckDescription.vue?vue&type=script&lang=js"
export * from "./TruckDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__